import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import API from "@unisearch/helpers/api";
import { useRouter } from "next/router";
import { useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import { useRecoilValue } from "recoil";
import { saveAs } from "file-saver";
import { MdPictureAsPdf } from "react-icons/md";
import { getFileExtension, swalError } from "@unisearch/helpers";

import styles from "./download_guide.module.scss";

/*
documentType -> 'prospectus', 'exam', 'document', 'course', 'ebook', 'countryguide'

This componetn takes props
-> fileSrc
-> fileName
-> btnTitle
-> documentType
-> universityId
-> documentId
-> customClasses={
        root.[your class name]
    }
-> customClasses={
        title.[your class name]
   }
-> customClasses={
        tooltip.[your class name]
    }
-> customStyles={{ root: { color: "blue" } }}
-> customStyles={{ title: { fontSize: "30px" } }}
-> customStyles={{ tooltip: { color: "blue" } }}
 */

export const DownloadGuide = ({
  fileSrc,
  btnTitle,
  fileName,
  documentType = "prospectus",
  customClasses,
  customStyles,
  universityId = 0,
  documentId = 0,
  ...props
}) => {
  const router = useRouter();
  const systemActions = useSystemActions();
  const profileInfos = useRecoilValue(authAtom);
  const [profileInfo, setProfileInfo] = useState();

  useEffect(() => {
    setProfileInfo(profileInfos);
  }, []);

  const storeStudentDownloadInfo = async () => {
    try {
      await API.post(`/student/download-activity`, {
        universityId,
        type: documentType,
        mediaId: documentId,
      }).then((res) => {});
    } catch (error) {
      swalError("Something went wrong");
    }
  };

  const handleDownload = async (fileSrc) => {
    if (!profileInfo) {
      systemActions.setReturnUrl(router.asPath);
      return router.push({ pathname: "/signin" });
    }
    if (profileInfo && profileInfo.userTypeSlug === "student") {
      storeStudentDownloadInfo();
    }
    window.open(fileSrc, "_blank");
  };

  return (
    <button
      onClick={() => {
        handleDownload(fileSrc);
      }}
      className={`btn btn-secondary relative ${
        customClasses?.root ? customClasses?.root : ""
      }`}
      style={customStyles?.root}
    >
      <MdPictureAsPdf />
      <span
        className={`${customClasses?.title ? customClasses?.title : ""}`}
        style={customStyles?.title}
      >
        {btnTitle || "Download Brochure"}
      </span>
      {!profileInfo && (
        <span
          className={`uni-tooltip ${
            customClasses?.tooltip ? customClasses?.tooltip : ""
          }`}
          style={customStyles?.tooltip}
        >
          Please Login <br /> to perform this action
        </span>
      )}
    </button>
  );
};

DownloadGuide.propTypes = {
  fileSrc: PropTypes.string,
  btnTitle: PropTypes.string,
  fileName: PropTypes.string,
  documentType: PropTypes.string.isRequired,
  universityId: PropTypes.number,
  documentId: PropTypes.number,
};

export default DownloadGuide;
